import(/* webpackMode: "eager" */ "/microservice/src/app/global-error.tsx");
